module.exports = __webpack_public_path__ + "static/media/pet.8da53993.svg";